module.exports = __webpack_public_path__ + "img/create_your_own.209ab2f8.png";